import { decamelize } from 'humps'
import { capitalize } from './capitalize'

/**
 * Formats text to title case: 'fooBar' => 'Foo Bar'
 *
 * @param text camelCase
 * @returns Title Case
 *
 */
const formatCamelToTitleCase = (text: string) =>
  decamelize(text, { separator: ' ' })
    .split(' ')
    .map(word => capitalize(word))
    .join(' ')

export default formatCamelToTitleCase
